import { safeSessionStorage } from "@/utils/safeStorages";
import siteConfig from "@/variables";
import { Game } from "@riot-private/commerce-contentcodes-client/lib";
import { useEffect, useState } from "react";
import { PATHS } from "../helpers/navigate";
import { getCurrentLocale } from "../providers/LocaleSwitcherProvider";

const supportedThemes = ["lol", "riot", "lor", "tft", "valorant", "wildrift"] as const;
type RiotTheme = (typeof supportedThemes)[number];
enum gameToThemeMapping {
  LOL = "lol",
  LOR = "lor",
  TFT = "tft",
  VAL = "valorant",
  WR = "wildrift",
  NONE = "riot",
  LION = "lion",
}

export const useTheme = () => {
  const theme = (safeSessionStorage.getItem(siteConfig.KEY_REDEEM_THEME) || "riot") as RiotTheme;
  const [currentTheme, setCurrentTheme] = useState(theme);

  const setNewTheme = (theme: RiotTheme) => {
    setCurrentTheme(theme);
    safeSessionStorage.setItem(siteConfig.KEY_REDEEM_THEME, theme);
  };

  const gameToTheme = (game: Game): RiotTheme => {
    return gameToThemeMapping[game] as RiotTheme;
  };

  useEffect(() => {
    let themeQueryParam;
    let landingPagePath;
    if (typeof window !== "undefined") {
      themeQueryParam = new URLSearchParams(window.location.search).get("theme") as RiotTheme;
      landingPagePath = `/${getCurrentLocale(window.location.pathname)}${PATHS.REDEEM}/`;
      if (supportedThemes.includes(themeQueryParam)) {
        setNewTheme(themeQueryParam);
      } else if (window.location.pathname === landingPagePath) {
        setNewTheme("riot");
      } else {
        const sessionTheme = safeSessionStorage.getItem(siteConfig.KEY_REDEEM_THEME) as RiotTheme;
        sessionTheme ? setNewTheme(sessionTheme) : setNewTheme(currentTheme);
      }
    }
  }, []);

  return { currentTheme, gameToTheme, setNewTheme };
};
